/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {DynamicComponentDirective as ɵa} from './lib/dynamic-component.directive';